export const STANDARD = 'STANDARD';
export const DEFAULT = 'DEFAULT';
export const FORECAST = 'FORECAST';
export const DESC = 1;
export const ASC = -1;